import URL from '@/interface/index'
import { postJson } from '@/assets/script/http'

const workbench = {
  deleteWf: params => postJson(URL.workbench.workflow.deleteList, params),
}

export default workbench